import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Globe } from 'lucide-react';
import { Button } from './ui/Button';
import { buildCheckoutUrl } from '../utils/checkout';
export function LastChance() {
  return <section className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-103" data-mp="1sjm30o04s98z">
      <div className="absolute inset-0 bg-stadium-glow opacity-80 pointer-events-none" data-id="element-104" data-mp="1nmca2ydj9fge"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-105" data-mp="1jkqz5ikk7b8u">
        <div className="max-w-3xl mx-auto text-center" data-id="element-106" data-mp="1jmbuhaep6y7r">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-107" data-mp="1eshbk96x2n9q">
            <h2 className="font-anton text-5xl md:text-6xl text-white uppercase tracking-wide mb-8" data-id="element-108" data-mp="zvzzffqwl4m4">
              DERNIÈRE CHANCE
            </h2>

            <div className="prose prose-lg prose-invert mx-auto text-gray-300 mb-12" data-id="element-109" data-mp="vv6bimdgnpt8">
              <p className="text-xl font-medium text-white" data-id="element-110" data-mp="2indas7nioi9x">
                Vos joueurs de football méritent la meilleure version de
                vous-même.
              </p>
              <p data-id="element-111" data-mp="28qqr3m6xfx9h">
                Pas un entraîneur qui improvise à chaque séance d'entraînement.
              </p>
              <p data-id="element-112" data-mp="2dptuz3b67xfv">
                Arrêtez de passer vos soirées à chercher des exercices.
                <br data-id="element-113" data-mp="31fo8zo787s1p" />
                Arrêtez de construire vos séances à partir de zéro.
              </p>
              <p className="text-xl text-gold-400 font-medium mt-6" data-id="element-114" data-mp="36cen45zh0dkh">
                Prenez le contrôle de votre saison avec un système
                d'entraînement complet conçu pour vous faire gagner du temps et
                former de meilleurs joueurs de football.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-navy-950 border border-navy-700 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-115" data-mp="1h0w1rpj2k7kt">
            <h3 className="font-anton text-3xl md:text-4xl text-white uppercase tracking-wide mb-2" data-id="element-116" data-mp="3dvnujtof226w">
              FOOTBALL PRÊT : SYSTÈME 365
            </h3>
            <p className="font-oswald text-xl text-gold-500 uppercase tracking-widest mb-8" data-id="element-117" data-mp="34x3k1ft0eytr">
              6 Volumes Complets + 5 Bonus Premium
            </p>

            <div className="mb-8" data-id="element-118" data-mp="2zzk66h084o2c">
              <div className="text-gray-400 font-oswald text-lg line-through mb-1" data-id="element-119" data-mp="2uxuqup5yxo8g">
                Prix Normal : 97 USD
              </div>
              <div className="text-gold-500 font-oswald text-xl uppercase tracking-widest mb-1" data-id="element-120" data-mp="2q0unim0i6zl1">
                Aujourd'hui Seulement :
              </div>
              <div className="font-anton text-6xl text-white tracking-wider mb-3" data-id="element-121" data-mp="o7evplsojeoh">
                19 USD
              </div>
              <p className="inline-flex items-center gap-2 text-gold-400 text-sm font-medium" data-id="element-122" data-mp="wo5q8u67s51t">
                <Globe className="w-4 h-4" data-id="element-123" data-mp="10ph8ufqo7q0i" />
                Payez en toute sécurité dans votre devise locale.
              </p>
            </div>

            <div className="flex flex-col items-center gap-6" data-id="element-124" data-mp="15jlgl17rg22n">
              <Button size="xl" fullWidth onClick={() => {
              ;
              (window as any).fbq?.('track', 'InitiateCheckout', {
                value: 19,
                currency: 'USD'
              });
              window.location.href = buildCheckoutUrl();
            }} data-id="element-125" data-mp="1af0u1s1uvvyj">
                OUI, JE VEUX FOOTBALL PRÊT MAINTENANT
              </Button>

              <div className="text-green-400 font-medium" data-id="element-126" data-mp="1y5wqx3l65hcn">
                Accès Immédiat — Livré Par E-mail
              </div>

              <div className="flex flex-col items-center gap-3" data-id="element-127" data-mp="234815ffdltve">
                <div className="flex items-center gap-1" data-id="element-128" data-mp="236u4f2v8hn7t">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-129" data-mp="3734ndcta33sp" data-mpi={i} />)}
                  <span className="ml-2 font-oswald text-lg text-gray-200" data-id="element-130" data-mp="3l3xhvxjkxyvt">
                    4.9/5 — Avis Vérifiés
                  </span>
                </div>

                <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-131" data-mp="3uzs8pfxyj09o">
                  <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-132" data-mp="3q2iihy2qukks" />
                  <span data-id="element-133" data-mp="7nq32sdg8rtx">
                    Garantie Satisfait ou Remboursé 7 Jours — Zéro Risque
                  </span>
                </div>

                <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-134" data-mp="3nfmymvy0l1c">
                  <Globe className="w-4 h-4 text-gold-500" data-id="element-135" data-mp="hmyt5a571mb0" />
                  <span data-id="element-136" data-mp="cn2rhhjyy6ym">Payez Dans Votre Devise Locale</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}